var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PortfolioV1, AvailableLiquidityV1, PositionCardV1, MarketTableV1, TokenActionModalV1, NotificationComp, useWindowSizes, } from 'ui-kit';
import { getIcon } from '../utils/getIcon';
import { usePositionCapId } from '../hooks/usePositionCapId';
import { useAlphalendEventSubscription } from '../hooks/useAlphalendEventSubscription';
import { useMemo, useState } from 'react';
import { marketsArray } from '../data/marketInfo';
import { useBalances } from '../context/BalanceContext';
import { alphalendTransactionHandler, claimRewardsTransactionHandler, } from '../utils/alphalendTransactionHandler';
import { useSignAndExecuteTransaction } from '@mysten/dapp-kit';
import { alphalendWebSocketService } from '../services/alphalendWebsocket';
import SwapModal from '../components/SwapModal';
import { SwapButton } from '../components/SwapButton';
const Markets = ({ walletConnectFunctionality, themeName, address }) => {
    const { positionCapId } = usePositionCapId();
    const { walletBalancesMap } = useBalances();
    const { mutate: signAndExecuteTransaction } = useSignAndExecuteTransaction();
    const [supplySortConfig, setSupplySortConfig] = useState({ key: 'symbol', direction: null });
    const [borrowSortConfig, setBorrowSortConfig] = useState({ key: 'symbol', direction: null });
    const [modalState, setModalState] = useState({
        isOpen: false,
        token: null,
        actionType: null,
    });
    const [activeTab, setActiveTab] = useState('Supply');
    const [isTransactionLoading, setIsTransactionLoading] = useState(false);
    const [resetInputTrigger, setResetInputTrigger] = useState(0);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [notificationInfo, setNotificationInfo] = useState({
        title: '',
        description: '',
        link: '',
        image: undefined,
        spinner: false,
    });
    const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);
    const { data: portfolioHighFreqData } = useAlphalendEventSubscription(positionCapId ? `portfolio:${positionCapId}` : null, positionCapId ? `portfolio:${positionCapId}_high_freq` : null);
    const { data: portfolioLowFreqData } = useAlphalendEventSubscription(positionCapId ? `portfolio:${positionCapId}` : null, positionCapId ? `portfolio:${positionCapId}_low_freq` : null);
    const { data: marketHighFreqData } = useAlphalendEventSubscription('market_data', 'market_data_high_freq');
    const { data: marketLowFreqData } = useAlphalendEventSubscription('market_data', 'market_data_low_freq');
    const screenWidth = useWindowSizes();
    const prepareTokenForModal = (token) => {
        if (!token) {
            return {
                symbol: '',
                icon: '',
                price: '0',
                marketId: '',
                isSupplyEnabled: false,
                isBorrowEnabled: false,
            };
        }
        const marketToken = allMarketTokens.find((t) => t.marketId === token.marketId);
        return Object.assign(Object.assign({}, token), { walletBalance: token.inWallet || '0', totalBorrowedUsd: token.borrowedBalanceUSD || '0', totalSupplyUsd: token.supplyBalanceUSD || '0', supplyToolTipItems: token.supplyToolTipItems || (marketToken === null || marketToken === void 0 ? void 0 : marketToken.supplyToolTipItems), borrowToolTipItems: token.borrowToolTipItems || (marketToken === null || marketToken === void 0 ? void 0 : marketToken.borrowToolTipItems) });
    };
    const handleSupply = (token) => {
        setModalState({
            isOpen: true,
            token: token,
            actionType: 'Supply',
        });
        setActiveTab('Supply');
    };
    const handleBorrow = (token) => {
        setModalState({
            isOpen: true,
            token: token,
            actionType: 'Borrow',
        });
        setActiveTab('Borrow');
    };
    const handleWithdraw = (token) => {
        setModalState({
            isOpen: true,
            token: token,
            actionType: 'Withdraw',
        });
        setActiveTab('Withdraw');
    };
    const handleRepay = (token) => {
        setModalState({
            isOpen: true,
            token: token,
            actionType: 'Repay',
        });
        setActiveTab('Repay');
    };
    const handleCloseModal = () => {
        setModalState({
            isOpen: false,
            token: null,
            actionType: null,
        });
        setResetInputTrigger((prev) => prev + 1);
    };
    const handleSwapNotification = (info) => {
        setNotificationInfo({
            title: info.title,
            description: info.description,
            spinner: info.spinner || false,
            link: info.link || '',
            image: info.image || undefined,
        });
        setIsNotificationOpen(true);
    };
    const handleSubmit = (amount, action, displayAmount) => __awaiter(void 0, void 0, void 0, function* () {
        if (!address || !modalState.token) {
            console.error('Missing required data for transaction');
            return;
        }
        const suiBalance = (walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get('0x2::sui::SUI')) || '0';
        const suppliedAndBorrowedCoinTypes = [];
        if (portfolioLowFreqData) {
            const suppliedMarkets = Object.keys(portfolioLowFreqData.supplied_amounts || {});
            const borrowedMarkets = Object.keys(portfolioLowFreqData.borrowed_amounts || {});
            const allMarketIds = [...new Set([...suppliedMarkets, ...borrowedMarkets])];
            allMarketIds.forEach((marketId) => {
                const market = marketsArray.find((m) => m.id === marketId);
                if (market) {
                    suppliedAndBorrowedCoinTypes.push(market.coinType);
                }
            });
            const currentMarket = marketsArray.find((m) => { var _a; return m.id === ((_a = modalState.token) === null || _a === void 0 ? void 0 : _a.marketId); });
            if (currentMarket && !suppliedAndBorrowedCoinTypes.includes(currentMarket.coinType)) {
                suppliedAndBorrowedCoinTypes.push(currentMarket.coinType);
            }
        }
        yield alphalendTransactionHandler({
            amount: amount,
            network: 'mainnet',
            action: action,
            modalState: modalState,
            address: address,
            positionCapId: positionCapId,
            signAndExecuteTransaction: signAndExecuteTransaction,
            setNotificationInfo: setNotificationInfo,
            setIsNotificationOpen: setIsNotificationOpen,
            setIsTransactionLoading: setIsTransactionLoading,
            displayAmount: displayAmount,
            suiBalance: suiBalance,
            resetInputValues: () => {
                setResetInputTrigger((prev) => prev + 1);
                handleCloseModal();
            },
            notifyTransaction: (marketId, positionCapId, txType) => {
                console.log(`📡 Notifying WebSocket server: ${txType} transaction for market ${marketId}, position ${positionCapId || 'NEW'}`);
                alphalendWebSocketService.sendTransactionNotification(marketId, positionCapId, txType);
            },
            suppliedAndBorrowedCoinTypes: suppliedAndBorrowedCoinTypes,
        });
    });
    const handleClaimRewards = (claimAlpha, claimAll) => __awaiter(void 0, void 0, void 0, function* () {
        if (!address || !positionCapId) {
            console.error('Address and Position Cap ID are required for claiming rewards');
            return;
        }
        const suiBalance = (walletBalancesMap === null || walletBalancesMap === void 0 ? void 0 : walletBalancesMap.get('0x2::sui::SUI')) || '0';
        yield claimRewardsTransactionHandler({
            address: address,
            positionCapId: positionCapId,
            network: 'mainnet',
            notifyTransaction: (positionCapId) => {
                console.log(`💰 [CLAIM_REWARD] Sending notification to WebSocket server for position:`, positionCapId);
                alphalendWebSocketService.sendClaimRewardsNotification(positionCapId);
            },
            signAndExecuteTransaction: signAndExecuteTransaction,
            setNotificationInfo: setNotificationInfo,
            setIsNotificationOpen: setIsNotificationOpen,
            setIsTransactionLoading: setIsTransactionLoading,
            claimAll: claimAll,
            claimAlpha: claimAlpha,
            suiBalance: suiBalance,
            resetInputValues: undefined,
        });
    });
    const allMarketTokens = useMemo(() => {
        if (!marketHighFreqData || !marketLowFreqData) {
            return [];
        }
        const tokens = [];
        marketsArray.forEach((marketInfo) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const marketId = marketInfo.id;
            const marketHigh = marketHighFreqData.markets[marketId];
            const marketLow = (_a = marketLowFreqData.markets) === null || _a === void 0 ? void 0 : _a[marketId];
            if (!marketHigh || !marketLow) {
                return;
            }
            const price = marketHigh.price || '0';
            const supplyApr = ((_b = marketLow.supply_apr) === null || _b === void 0 ? void 0 : _b.total) || '0';
            const borrowApr = ((_c = marketLow.borrow_apr) === null || _c === void 0 ? void 0 : _c.total) || '0';
            const supplyBalance = ((_d = portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.supplied_amounts) === null || _d === void 0 ? void 0 : _d[marketId]) || '0';
            const borrowedBalance = ((_e = portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.borrowed_amounts) === null || _e === void 0 ? void 0 : _e[marketId]) || '0';
            const supplyToolTipItems = [];
            if (marketLow.supply_apr) {
                if (marketLow.supply_apr.interest) {
                    supplyToolTipItems.push({
                        icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                        label: 'Supply APR',
                        value: `${marketLow.supply_apr.interest}%`,
                    });
                }
                if (marketLow.supply_apr.rewards && marketLow.supply_apr.rewards.length > 0) {
                    marketLow.supply_apr.rewards.forEach((reward) => {
                        const tokenSymbol = reward.token.split('::').pop() || reward.token;
                        supplyToolTipItems.push({
                            icon: tokenSymbol === 'staking_apr'
                                ? getIcon('stsui')
                                : getIcon(tokenSymbol.toLowerCase()),
                            label: `${tokenSymbol === 'staking_apr' ? 'Staking' : tokenSymbol.toUpperCase()} APR`,
                            value: `${reward.apr}%`,
                        });
                    });
                }
                if (supplyToolTipItems.length > 0) {
                    supplyToolTipItems.push({
                        icon: '',
                        label: 'TOTAL APR',
                        value: `${marketLow.supply_apr.total}%`,
                    });
                }
            }
            const borrowToolTipItems = [];
            if (marketLow.borrow_apr) {
                if (marketLow.borrow_apr.interest) {
                    borrowToolTipItems.push({
                        icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                        label: 'Borrow APR',
                        value: `${marketLow.borrow_apr.interest}%`,
                    });
                }
                if (marketLow.borrow_apr.rewards && marketLow.borrow_apr.rewards.length > 0) {
                    marketLow.borrow_apr.rewards.forEach((reward) => {
                        const tokenSymbol = reward.token.split('::').pop() || reward.token;
                        borrowToolTipItems.push({
                            icon: tokenSymbol === 'staking_apr'
                                ? getIcon('stsui')
                                : getIcon(tokenSymbol.toLowerCase()),
                            label: `${tokenSymbol === 'staking_apr' ? 'Staking' : tokenSymbol.toUpperCase()} APR`,
                            value: `[${reward.apr}%]`,
                        });
                    });
                }
                if (borrowToolTipItems.length > 0) {
                    borrowToolTipItems.push({
                        icon: '',
                        label: 'TOTAL APR',
                        value: `${marketLow.borrow_apr.total}%`,
                    });
                }
            }
            // Check if supply cap is reached
            const allowedSupplyAmount = parseFloat(marketLow.allowed_supply_amount || '0');
            const isSupplyCapReached = allowedSupplyAmount <= 0;
            tokens.push({
                marketId,
                symbol: marketInfo.symbol,
                icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                price,
                totalSupply: marketHigh.total_supply || '0',
                totalBorrowed: (parseFloat(marketHigh.total_supply || '0') -
                    parseFloat(marketHigh.available_liquidity || '0')).toString(),
                available: marketHigh.available_liquidity || '0',
                supplyApr,
                borrowApr,
                ltv: marketLow.ltv || '0',
                borrowFee: marketLow.borrow_fee || '0',
                isSupplyEnabled: borrowedBalance === '0' &&
                    !['ALKIMI', 'UP'].includes(marketInfo.symbol) &&
                    !isSupplyCapReached, // Disable when supply cap is reached
                isBorrowEnabled: supplyBalance === '0',
                supplyBalance,
                borrowedBalance,
                supplyBalanceUSD: (parseFloat(supplyBalance) * parseFloat(price)).toString(),
                borrowedBalanceUSD: (parseFloat(borrowedBalance) * parseFloat(price)).toString(),
                totalSupplySubText: (parseFloat(marketHigh.total_supply || '0') * parseFloat(price)).toFixed(2),
                availableSubText: (parseFloat(marketHigh.available_liquidity || '0') * parseFloat(price)).toFixed(2),
                supplyToolTipItems: supplyToolTipItems.length > 0 ? supplyToolTipItems : undefined,
                borrowToolTipItems: borrowToolTipItems.length > 0 ? borrowToolTipItems : undefined,
                isSupplyRewardsEnabled: ((_f = marketLow.supply_apr) === null || _f === void 0 ? void 0 : _f.rewards) && marketLow.supply_apr.rewards.length > 0,
                isBorrowRewardsEnabled: ((_g = marketLow.borrow_apr) === null || _g === void 0 ? void 0 : _g.rewards) && marketLow.borrow_apr.rewards.length > 0,
                allowedSupplyAmount: marketLow.allowed_supply_amount || '0',
                allowedBorrowAmount: marketLow.allowed_borrow_amount || '0',
                borrowWeight: marketLow.borrow_weight || '0',
                liquidationThreshold: marketLow.liquidation_threshold || '0',
                spreadFee: marketLow.spread_fee || '0',
                utilizationRate: marketLow.utilization_rate || '0',
                interestRateKinks: marketLow.interest_rate_kinks || [],
                interestRates: marketLow.interest_rates || [],
                inWallet: walletBalancesMap
                    ? (parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                        Math.pow(10, marketInfo.expo)).toString()
                    : '0',
                inWalletUSD: walletBalancesMap
                    ? ((parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                        Math.pow(10, marketInfo.expo)) *
                        parseFloat(price)).toString()
                    : '0',
                retired: marketInfo.symbol === 'ALKIMI' || marketInfo.symbol === 'UP',
                safeBorrowLimit: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) || '0',
                borrowLimitUsed: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.borrow_limit_used) || '0',
            });
        });
        return tokens;
    }, [
        marketHighFreqData,
        marketLowFreqData,
        portfolioLowFreqData,
        portfolioHighFreqData,
        walletBalancesMap,
    ]);
    const portfolioSections = useMemo(() => {
        const supplyTokens = [];
        const borrowTokens = [];
        if (!portfolioLowFreqData || !marketHighFreqData) {
            return { supply: { tokens: [] }, borrow: { tokens: [] } };
        }
        if (portfolioLowFreqData.supplied_amounts) {
            Object.entries(portfolioLowFreqData.supplied_amounts).forEach(([marketId, amount]) => {
                var _a, _b, _c, _d;
                if (parseFloat(amount) > 0) {
                    const marketHigh = (_a = marketHighFreqData.markets) === null || _a === void 0 ? void 0 : _a[marketId];
                    const marketLow = (_b = marketLowFreqData === null || marketLowFreqData === void 0 ? void 0 : marketLowFreqData.markets) === null || _b === void 0 ? void 0 : _b[marketId];
                    const marketInfo = marketsArray.find((m) => m.id === marketId);
                    if (!marketInfo || (!marketHigh && !marketLow)) {
                        return;
                    }
                    const price = (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.price) || '0';
                    const balanceUSD = (parseFloat(amount) * parseFloat(price)).toString();
                    const supplyApr = ((_c = marketLow === null || marketLow === void 0 ? void 0 : marketLow.supply_apr) === null || _c === void 0 ? void 0 : _c.total) || '0';
                    const supplyToolTipItems = [];
                    if (marketLow === null || marketLow === void 0 ? void 0 : marketLow.supply_apr) {
                        if (marketLow.supply_apr.interest) {
                            supplyToolTipItems.push({
                                icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                                label: 'Supply APR',
                                value: `${marketLow.supply_apr.interest}%`,
                            });
                        }
                        if (marketLow.supply_apr.rewards && marketLow.supply_apr.rewards.length > 0) {
                            marketLow.supply_apr.rewards.forEach((reward) => {
                                const tokenSymbol = reward.token.split('::').pop() || reward.token;
                                const tokenLowerCase = tokenSymbol.toLowerCase();
                                supplyToolTipItems.push({
                                    icon: tokenSymbol === 'staking_apr'
                                        ? getIcon('stsui')
                                        : getIcon(tokenLowerCase),
                                    label: `${tokenSymbol === 'staking_apr' ? 'Staking' : tokenSymbol.toUpperCase()} APR`,
                                    value: `${reward.apr}%`,
                                });
                            });
                        }
                        if (supplyToolTipItems.length > 0) {
                            supplyToolTipItems.push({
                                icon: '',
                                label: 'TOTAL APR',
                                value: `${marketLow.supply_apr.total}%`,
                            });
                        }
                    }
                    // Check if supply cap is reached
                    const allowedSupplyAmount = parseFloat((marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_supply_amount) || '0');
                    const isSupplyCapReached = allowedSupplyAmount <= 0;
                    supplyTokens.push({
                        marketId,
                        symbol: marketInfo.symbol, // Get actual symbol from market metadata
                        icon: getIcon(marketInfo.symbol.toLocaleLowerCase()), // Get actual icon from market metadata
                        price,
                        isSupplyEnabled: !isSupplyCapReached, // Disable when supply cap is reached
                        isBorrowEnabled: false,
                        balance: amount,
                        balanceUSD,
                        supplyBalance: amount,
                        supplyBalanceUSD: balanceUSD,
                        apr: supplyApr,
                        supplyApr,
                        supplyToolTipItems: supplyToolTipItems.length > 0 ? supplyToolTipItems : undefined,
                        isSupplyRewardsEnabled: ((_d = marketLow === null || marketLow === void 0 ? void 0 : marketLow.supply_apr) === null || _d === void 0 ? void 0 : _d.rewards) && marketLow.supply_apr.rewards.length > 0,
                        ltv: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.ltv) || '0',
                        borrowFee: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_fee) || '0',
                        liquidationThreshold: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.liquidation_threshold) || '0',
                        spreadFee: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.spread_fee) || '0',
                        borrowWeight: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_weight) || '0',
                        interestRateKinks: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.interest_rate_kinks) || [],
                        interestRates: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.interest_rates) || [],
                        allowedSupplyAmount: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_supply_amount) || '0',
                        allowedBorrowAmount: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_borrow_amount) || '0',
                        totalSupply: (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.total_supply) || '0',
                        available: (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.available_liquidity) || '0',
                        totalBorrowed: (parseFloat((marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.total_supply) || '0') -
                            parseFloat((marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.available_liquidity) || '0')).toString(),
                        utilizationRate: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.utilization_rate) || '0',
                        safeBorrowLimit: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) || '0',
                        borrowLimitUsed: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.borrow_limit_used) || '0',
                        inWallet: walletBalancesMap
                            ? (parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                                Math.pow(10, marketInfo.expo)).toString()
                            : '0',
                        inWalletUSD: walletBalancesMap
                            ? ((parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                                Math.pow(10, marketInfo.expo)) *
                                parseFloat(price)).toString()
                            : '0',
                    });
                }
            });
        }
        if (portfolioLowFreqData.borrowed_amounts) {
            Object.entries(portfolioLowFreqData.borrowed_amounts).forEach(([marketId, amount]) => {
                var _a, _b, _c, _d;
                if (parseFloat(amount) > 0) {
                    const marketHigh = (_a = marketHighFreqData.markets) === null || _a === void 0 ? void 0 : _a[marketId];
                    const marketLow = (_b = marketLowFreqData === null || marketLowFreqData === void 0 ? void 0 : marketLowFreqData.markets) === null || _b === void 0 ? void 0 : _b[marketId];
                    const marketInfo = marketsArray.find((m) => m.id === marketId);
                    if (!marketInfo || (!marketHigh && !marketLow)) {
                        return;
                    }
                    const price = (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.price) || '0';
                    const balanceUSD = (parseFloat(amount) * parseFloat(price)).toString();
                    const borrowApr = ((_c = marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_apr) === null || _c === void 0 ? void 0 : _c.total) || '0';
                    const borrowToolTipItems = [];
                    if (marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_apr) {
                        if (marketLow.borrow_apr.interest) {
                            borrowToolTipItems.push({
                                icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                                label: 'Borrow APR',
                                value: `${marketLow.borrow_apr.interest}%`,
                            });
                        }
                        if (marketLow.borrow_apr.rewards && marketLow.borrow_apr.rewards.length > 0) {
                            marketLow.borrow_apr.rewards.forEach((reward) => {
                                const tokenSymbol = reward.token.split('::').pop() || reward.token;
                                const tokenLowerCase = tokenSymbol.toLowerCase();
                                borrowToolTipItems.push({
                                    icon: getIcon(tokenLowerCase),
                                    label: `${tokenSymbol.toUpperCase()} APR`,
                                    value: `[${reward.apr}%]`,
                                });
                            });
                        }
                        if (borrowToolTipItems.length > 0) {
                            borrowToolTipItems.push({
                                icon: '',
                                label: 'TOTAL APR',
                                value: `${marketLow.borrow_apr.total}%`,
                            });
                        }
                    }
                    borrowTokens.push({
                        marketId,
                        symbol: marketInfo.symbol,
                        icon: getIcon(marketInfo.symbol.toLocaleLowerCase()),
                        price,
                        isSupplyEnabled: false,
                        isBorrowEnabled: true,
                        balance: amount,
                        balanceUSD,
                        borrowedBalance: amount,
                        borrowedBalanceUSD: balanceUSD,
                        apr: borrowApr,
                        borrowApr,
                        borrowToolTipItems: borrowToolTipItems.length > 0 ? borrowToolTipItems : undefined,
                        isBorrowRewardsEnabled: ((_d = marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_apr) === null || _d === void 0 ? void 0 : _d.rewards) && marketLow.borrow_apr.rewards.length > 0,
                        ltv: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.ltv) || '0',
                        borrowFee: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_fee) || '0',
                        liquidationThreshold: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.liquidation_threshold) || '0',
                        spreadFee: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.spread_fee) || '0',
                        borrowWeight: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.borrow_weight) || '0',
                        interestRateKinks: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.interest_rate_kinks) || [],
                        interestRates: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.interest_rates) || [],
                        allowedSupplyAmount: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_supply_amount) || '0',
                        allowedBorrowAmount: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.allowed_borrow_amount) || '0',
                        totalSupply: (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.total_supply) || '0',
                        available: (marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.available_liquidity) || '0',
                        totalBorrowed: (parseFloat((marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.total_supply) || '0') -
                            parseFloat((marketHigh === null || marketHigh === void 0 ? void 0 : marketHigh.available_liquidity) || '0')).toString(),
                        utilizationRate: (marketLow === null || marketLow === void 0 ? void 0 : marketLow.utilization_rate) || '0',
                        safeBorrowLimit: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) || '0',
                        borrowLimitUsed: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.borrow_limit_used) || '0',
                        inWallet: walletBalancesMap
                            ? (parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                                Math.pow(10, marketInfo.expo)).toString()
                            : '0',
                        inWalletUSD: walletBalancesMap
                            ? ((parseFloat(walletBalancesMap.get(marketInfo.coinType) || '0') /
                                Math.pow(10, marketInfo.expo)) *
                                parseFloat(price)).toString()
                            : '0',
                    });
                }
            });
        }
        return {
            supply: { tokens: supplyTokens },
            borrow: { tokens: borrowTokens },
        };
    }, [
        portfolioLowFreqData,
        marketHighFreqData,
        marketLowFreqData,
        portfolioHighFreqData,
        walletBalancesMap,
    ]);
    const [marketTableSortConfig, setMarketTableSortConfig] = useState({ key: 'symbol', direction: null });
    const handleMarketTableSort = (key) => {
        setMarketTableSortConfig((prev) => {
            if (prev.key !== key) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === null) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === 'asc') {
                return { key, direction: 'desc' };
            }
            return { key, direction: null };
        });
    };
    const sortedMarketTableTokens = useMemo(() => {
        if (!marketTableSortConfig.direction)
            return allMarketTokens;
        return [...allMarketTokens].sort((a, b) => {
            const aValue = a[marketTableSortConfig.key];
            const bValue = b[marketTableSortConfig.key];
            if (aValue === undefined || bValue === undefined)
                return 0;
            let comparison = 0;
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                if (marketTableSortConfig.key === 'symbol') {
                    comparison = aValue.localeCompare(bValue);
                }
                else {
                    comparison = parseFloat(aValue) - parseFloat(bValue);
                }
            }
            else if (typeof aValue === 'number' && typeof bValue === 'number') {
                comparison = aValue - bValue;
            }
            return marketTableSortConfig.direction === 'asc' ? comparison : -comparison;
        });
    }, [allMarketTokens, marketTableSortConfig]);
    const handleSupplySort = (key) => {
        setSupplySortConfig((prev) => {
            if (prev.key !== key) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === null) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === 'asc') {
                return { key, direction: 'desc' };
            }
            return { key, direction: null };
        });
    };
    const handleBorrowSort = (key) => {
        setBorrowSortConfig((prev) => {
            if (prev.key !== key) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === null) {
                return { key, direction: 'asc' };
            }
            if (prev.direction === 'asc') {
                return { key, direction: 'desc' };
            }
            return { key, direction: null };
        });
    };
    const sortedSupplyTokens = useMemo(() => {
        if (!supplySortConfig.direction)
            return portfolioSections.supply.tokens;
        return [...portfolioSections.supply.tokens].sort((a, b) => {
            const aValue = a[supplySortConfig.key];
            const bValue = b[supplySortConfig.key];
            if (aValue === undefined || bValue === undefined)
                return 0;
            let comparison = 0;
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                if (supplySortConfig.key === 'symbol') {
                    comparison = aValue.localeCompare(bValue);
                }
                else {
                    comparison = parseFloat(aValue) - parseFloat(bValue);
                }
            }
            else if (typeof aValue === 'number' && typeof bValue === 'number') {
                comparison = aValue - bValue;
            }
            return supplySortConfig.direction === 'asc' ? comparison : -comparison;
        });
    }, [portfolioSections.supply.tokens, supplySortConfig]);
    const sortedBorrowTokens = useMemo(() => {
        if (!borrowSortConfig.direction)
            return portfolioSections.borrow.tokens;
        return [...portfolioSections.borrow.tokens].sort((a, b) => {
            const aValue = a[borrowSortConfig.key];
            const bValue = b[borrowSortConfig.key];
            if (aValue === undefined || bValue === undefined)
                return 0;
            let comparison = 0;
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                if (borrowSortConfig.key === 'symbol') {
                    comparison = aValue.localeCompare(bValue);
                }
                else {
                    comparison = parseFloat(aValue) - parseFloat(bValue);
                }
            }
            else if (typeof aValue === 'number' && typeof bValue === 'number') {
                comparison = aValue - bValue;
            }
            return borrowSortConfig.direction === 'asc' ? comparison : -comparison;
        });
    }, [portfolioSections.borrow.tokens, borrowSortConfig]);
    const getRewardsDistribution = () => {
        if (!(portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.rewards_by_token))
            return [];
        return Object.entries(portfolioHighFreqData.rewards_by_token)
            .map(([coinType, amount]) => {
            const marketInfo = marketsArray.find((m) => m.coinType === coinType);
            if (!marketInfo) {
                console.warn(`Unknown reward token: ${coinType}`);
                return null;
            }
            return {
                label: marketInfo.symbol,
                amount: amount,
                icon: getIcon(marketInfo.symbol.toLowerCase()),
            };
        })
            .filter((entry) => entry !== null)
            .sort((a, b) => a.label.localeCompare(b.label));
    };
    const DAILY_EARNINGS_TOOLTIP = `
  <div style="font-family: system-ui, sans-serif; font-weight: bolder; margin-bottom: 0.33vw;">
    Daily Earnings = Daily Supply Interest − Daily Borrow<br/>Interest + Daily Rewards.
  </div>
  <div style="font-family: system-ui, sans-serif; font-weight: 300;">
    Supply Interest auto-compounds to your balance.<br/>
    Rewards requires manual claiming via "Claim Rewards".
  </div>
`;
    return (_jsxs("div", { className: "theme-bg-lndBody", children: [_jsx(PortfolioV1, { isWalletConnected: address ? true : false, title: "Supply & Borrow", subtitle: "Your supply and borrow positions", globalStats: {
                    availableLiquidity: (parseFloat((marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_supplied_usd) || '0') -
                        parseFloat((marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_borrowed_usd) || '0')).toString(),
                    supplied: (marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_supplied_usd) || '0',
                    borrowed: (marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_borrowed_usd) || '0',
                }, personalStats: {
                    netWorth: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.net_worth) || '0',
                    dailyEarnings: (portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.daily_earnings) || '0',
                    netApr: (portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.net_apr) || '0',
                    borrowLimitUsed: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.borrow_limit_used) || '0',
                    safeBorrowLimit: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) || '0',
                    pendingRewards: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.rewards_to_claim_usd) || '0',
                    borrowLimitUsedPercentage: (parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.borrow_limit_used) || '0') /
                        parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd) || '1')) *
                        100,
                    safeLimitPercentage: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) && (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd)
                        ? (parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.safe_borrow_limit) || '0') /
                            parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd) || '1')) *
                            100
                        : undefined,
                    liquidationPercentage: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.liquidation_limit) && (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd)
                        ? (parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.liquidation_limit) || '0') /
                            parseFloat((portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd) || '1')) *
                            100
                        : undefined,
                    rewards: getRewardsDistribution(),
                    rewardInstructions: [
                        'Claim ALPHA and deposit to ALPHA locked vault',
                        'Stake all rewards, except ALPHA, on AlphaLend',
                    ],
                }, closeIcon: themeName === 'dark' ? getIcon('darkCrossIcon') : getIcon('close'), hoverTexts: {
                    'Daily Earnings': DAILY_EARNINGS_TOOLTIP,
                }, infoIcon: getIcon('infoIcon'), onClaimRewards: handleClaimRewards, wordSpacing: "0.2vw", walletConnectFunctionality: walletConnectFunctionality, checkmarkIcon: getIcon('roundedGreenCheckIcon'), disableRewards: !address }), address && (_jsx("div", { className: `md:max-w-[1400px] mx-auto justify-center ${screenWidth.width <= 1024 ? 'px-[20px]' : ''} ${screenWidth.width < 728 ? 'px-[20px] pt-[20px]' : ''}`, children: _jsx(AvailableLiquidityV1, { totalLiquidityTitle: "Available Liquidity", supplyLiquidityTitle: "Supplied", borrowLiquidityTitle: "Borrowed", totalLiquidityValue: (parseFloat((marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_supplied_usd) || '0') -
                        parseFloat((marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_borrowed_usd) || '0')).toString(), supplyLiquidityValue: (marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_supplied_usd) || '0', borrowLiquidityValue: (marketHighFreqData === null || marketHighFreqData === void 0 ? void 0 : marketHighFreqData.total_borrowed_usd) || '0', expandIcon: themeName === 'dark' ? getIcon('expandIcon') : getIcon('expandIcon'), shrinkIcon: themeName === 'dark' ? getIcon('shrinkIcon') : getIcon('shrinkIcon') }) })), address && (_jsxs("div", { className: `flex justify-between md:max-w-[1400px] md:gap-4 mx-auto pt-[13.6px] md:pt-[19.2px] flex-col md:flex-row ${screenWidth.width < 728 ? 'items-center px-[20px]' : 'items-start'} ${screenWidth.width <= 1024 ? 'px-[20px]' : ''}`, children: [portfolioSections.supply.tokens.length > 0 && (_jsx("div", { className: `${screenWidth.width < 768 ? 'w-full' : 'w-[50%]'}  ${screenWidth.width === 768 ? 'md:w-[360px]' : ''}`, children: _jsx(PositionCardV1, { title: "Your Supplies", headerData: {
                                balance: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_supplied_usd) || '0',
                                apr: (portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.aggregated_supply_apr) || '0',
                            }, tokens: sortedSupplyTokens, actions: [
                                {
                                    label: 'supply',
                                    onClick: handleSupply,
                                    variant: 'primary',
                                },
                                {
                                    label: 'withdraw',
                                    onClick: handleWithdraw,
                                    variant: 'secondary',
                                },
                            ], sortConfig: supplySortConfig, onSort: handleSupplySort, ArrowUp: themeName === 'dark' ? getIcon('darkThemeUpArrow') : getIcon('upArrowBlack'), ArrowDown: themeName === 'dark' ? getIcon('darkThemeDownArrow') : getIcon('downArrowBlack'), defaultArrow: themeName === 'dark' ? getIcon('darkThemeDefaultArrow') : getIcon('defaultArrow'), plusIcon: getIcon('plusIcon'), minusIcon: getIcon('minusIcon'), columnLabels: {
                                symbol: 'Assets',
                                balanceUSD: 'Balance',
                                apr: 'APR',
                            }, isSupply: true, onRowClick: () => console.log('Row clicked') }) })), portfolioSections.borrow.tokens.length > 0 && (_jsx("div", { className: `${screenWidth.width < 768 ? 'w-full' : 'w-[50%]'}  ${screenWidth.width === 768 ? 'md:w-[360px]' : ''}`, children: _jsx(PositionCardV1, { title: "Your Borrows", headerData: {
                                balance: (portfolioHighFreqData === null || portfolioHighFreqData === void 0 ? void 0 : portfolioHighFreqData.total_borrowed_usd) || '0',
                                apr: (portfolioLowFreqData === null || portfolioLowFreqData === void 0 ? void 0 : portfolioLowFreqData.aggregated_borrow_apr) || '0',
                            }, tokens: sortedBorrowTokens, actions: [
                                {
                                    label: 'borrow',
                                    onClick: handleBorrow,
                                    variant: 'primary',
                                },
                                {
                                    label: 'repay',
                                    onClick: handleRepay,
                                    variant: 'secondary',
                                },
                            ], sortConfig: borrowSortConfig, onSort: handleBorrowSort, ArrowUp: themeName === 'dark' ? getIcon('darkThemeUpArrow') : getIcon('upArrowBlack'), ArrowDown: themeName === 'dark' ? getIcon('darkThemeDownArrow') : getIcon('downArrowBlack'), defaultArrow: themeName === 'dark' ? getIcon('darkThemeDefaultArrow') : getIcon('defaultArrow'), plusIcon: getIcon('plusIcon'), minusIcon: getIcon('minusIcon'), columnLabels: {
                                symbol: 'Assets',
                                balanceUSD: 'Debt',
                                apr: 'APR',
                            }, isSupply: false, onRowClick: () => console.log('Row clicked') }) }))] })), _jsx("div", { className: `md:max-w-[1400px] mx-auto pb-[190px] ${screenWidth.width <= 1024 ? 'px-[20px]' : ''} ${screenWidth.width < 728 ? 'px-[20px]' : ''}`, children: _jsx(MarketTableV1, { tokens: sortedMarketTableTokens, sortUpIcon: themeName === 'dark' ? getIcon('darkThemeUpArrow') : getIcon('upArrowBlack'), sortDownIcon: themeName === 'dark' ? getIcon('darkThemeDownArrow') : getIcon('downArrowBlack'), sortDefaultIcon: themeName === 'dark' ? getIcon('darkThemeDefaultArrow') : getIcon('defaultArrow'), activeFilter: "All", onFilterChange: () => { }, onSupply: handleSupply, onBorrow: handleBorrow, sortConfig: marketTableSortConfig, onSort: handleMarketTableSort, sortRetiredMarkets: true, isWalletConnected: address ? true : false, walletConnectFunctionality: walletConnectFunctionality, onRowClick: () => console.log('Row clicked') }) }), _jsx(TokenActionModalV1, { isOpen: modalState.isOpen, token: prepareTokenForModal(modalState.token), onClose: handleCloseModal, onSubmit: handleSubmit, activeTab: activeTab, setActiveTab: setActiveTab, setIsTransactionLoading: setIsTransactionLoading, isTransactionLoading: isTransactionLoading, isWalletConnected: !!address, rightArrow: themeName === 'dark' ? getIcon('darkThemeRightArrow') : getIcon('rightArrow'), resetInputTrigger: resetInputTrigger }), _jsx(SwapButton, { isSwapModalOpen: isSwapModalOpen, onClick: () => setIsSwapModalOpen(true), themeName: themeName, isTokenActionModalOpen: modalState.isOpen }), _jsx(SwapModal, { isOpen: isSwapModalOpen, onClose: () => setIsSwapModalOpen(false), onNotification: handleSwapNotification, loading: isTransactionLoading, setLoading: setIsTransactionLoading, walletConnectFunctionality: walletConnectFunctionality, isWalletConnected: !!address, theme: themeName }), _jsx(NotificationComp, { isOpen: isNotificationOpen, setIsOpen: setIsNotificationOpen, info: notificationInfo })] }));
};
export default Markets;
